const thumbs = [
    {
        kind: 'avatar',
        variants: [
            {
                size: 'preview',
                width: 300,
                height: 300
            },
            {
                size: 'small',
                square: true,
                width: 100
            },
            {
                size: 'medium',
                square: true,
                width: 200
            },
            {
                size: 'large',
                square: true,
                width: 300
            }
        ]
    },
    {
        kind: 'other',
        variants: [
            {
                size: 'preview',
                width: 480,
                height: 320
            },
            {
                size: 'small',
                width: 960,
                height: 540
            },
            {
                size: 'medium',
                width: 1366,
                height: 768
            },
            {
                size: 'large',
                width: 1920,
                height: 1080
            }
        ]
    }
];

module.exports = thumbs;


/** WEBPACK FOOTER **
 ** ../src/config/thumbs.js
 **/